// Ready-to-use API clients, one per backend surface. (DataCentral = v4.)
// They are created and registered in `./http-clients`; this file re-exports each by name
// from the registry, so no importing file had to change. A module outside
// `@/` reaches the same client with `getHttpClient('<name>')` from `@/lib/http` instead.
import { getHttpClient } from '@/lib/http';
import './http-clients';

export { setComputeMetadataID } from './http-clients';

export const dataCentralApi = getHttpClient('dataCentralApi');
export const serviceApi = getHttpClient('serviceApi');
export const serviceApiV3 = getHttpClient('serviceApiV3');
export const foundationApi = getHttpClient('foundationApi');
export const foundationApiPublic = getHttpClient('foundationApiPublic');
export const computeApi = getHttpClient('computeApi');
export const eagleApi = getHttpClient('eagleApi');
export const authApiAuthed = getHttpClient('authApiAuthed');
export const authApi = getHttpClient('authApi');
export const dataCentralPublic = getHttpClient('dataCentralPublic');
